import { render, staticRenderFns } from "./ManageALFApprover.vue?vue&type=template&id=a30a0b1a"
import script from "./ManageALFApprover.vue?vue&type=script&lang=js"
export * from "./ManageALFApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports